import { storeAdapter } from '@tb-core/adapters/store/store-adapter';
import { devProxyResolve } from '@tb-core/helpers/browser/dev-proxy-resolve';
import { setAccessTokenHeader } from '@tb-core/helpers/client/auth';
import Fetch from '@tb-core/helpers/fetch';
import { nextStoreUrl } from '@tb-core/next/api/urls';
import { Store } from '@tb-core/types';
import { StoreResponse } from '@tb-core/types/stores';

export default async function getStore(storeId: number | string) {
    let res: Response;

    try {
        res = await Fetch({
            headers: setAccessTokenHeader(),
            host: '',
            url: devProxyResolve(nextStoreUrl, { storeId })
        });
    } catch (e) {
        console.error('Store request failed!', e);
        return {} as Store;
    }

    if (!res.ok) {
        console.error(
            'Store request failed! Reason:',
            res.status,
            res.statusText
        );
        return {} as Store;
    }

    return storeAdapter((await res.json()) as StoreResponse);
}
